import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.status');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-status',
template: templateSource || '',
    styles: [``],
})
export class PageKieraStatusComponent implements OnInit {
    public nodes: any[] = [];
    public filter: any = { type: '', status: '', group: '' };
    public groups: any[] = [];
    public selectedNode: any = null;
    public statusOptions: string[] = ['new', 'commissioning', 'ready', 'deploying', 'deployed', 'failed', 'on', 'off'];
    public nodeSize: number = 3;  // 1~3 (3=카드, 2=컴팩트, 1=미니마이즈)
    public nodeSizeClasses: string[] = [
        '',   // size 1: 미니마이즈 (리스트 형태, grid 미사용)
        'grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-12',
        'grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6',
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadGroups();
        await this.loadNodes();
        await this.service.render();
    }

    public async loadGroups() {
        const { code, data } = await wiz.call("groups");
        if (code === 200) this.groups = data.rows || data || [];
    }

    public async loadNodes() {
        const { code, data } = await wiz.call("nodes", this.filter);
        if (code === 200) this.nodes = data.rows || [];
        await this.service.render();
    }

    public getStatusColor(status: string): string {
        switch (status) {
            case 'new': return 'bg-zinc-500';
            case 'ready': return 'bg-green-500';
            case 'deployed': return 'bg-blue-500';
            case 'deploying': return 'bg-yellow-500';
            case 'error': case 'failed': return 'bg-red-500';
            case 'commissioning': return 'bg-purple-500';
            case 'on': return 'bg-green-500';
            case 'off': return 'bg-zinc-400';
            default: return 'bg-zinc-400';
        }
    }

    public getStatusBg(status: string): string {
        switch (status) {
            case 'new': return 'bg-zinc-50 border-zinc-300';
            case 'ready': return 'bg-green-50 border-green-200';
            case 'deployed': return 'bg-blue-50 border-blue-200';
            case 'deploying': return 'bg-yellow-50 border-yellow-200';
            case 'error': case 'failed': return 'bg-red-50 border-red-200';
            case 'commissioning': return 'bg-purple-50 border-purple-200';
            case 'on': return 'bg-green-50 border-green-200';
            case 'off': return 'bg-zinc-50 border-zinc-200';
            default: return 'bg-zinc-50 border-zinc-200';
        }
    }

    public getStatusTextColor(status: string): string {
        switch (status) {
            case 'new': return 'text-zinc-600';
            case 'ready': return 'text-green-600';
            case 'deployed': return 'text-blue-600';
            case 'deploying': return 'text-yellow-600';
            case 'error': case 'failed': return 'text-red-600';
            case 'commissioning': return 'text-purple-600';
            case 'on': return 'text-green-600';
            case 'off': return 'text-zinc-500';
            default: return 'text-zinc-500';
        }
    }

    // 그룹별 노드 그룹핑 (미니마이즈 모드용)
    public getGroupedNodes(): any[] {
        const groupMap: any = {};
        for (const node of this.nodes) {
            const gid = node.group_id || 0;
            if (!groupMap[gid]) {
                const group = this.groups.find((g: any) => g.id === gid);
                groupMap[gid] = { name: group ? group.name : 'Ungrouped', nodes: [] };
            }
            groupMap[gid].nodes.push(node);
        }
        return Object.values(groupMap);
    }

    public showNodeDetail(node: any) {
        this.selectedNode = node;
    }

    public closeDetail() {
        this.selectedNode = null;
    }

    public getGridClass(): string {
        return this.nodeSizeClasses[this.nodeSize - 1] || '';
    }

    public async changeNodeSize(delta: number) {
        this.nodeSize = Math.max(1, Math.min(3, this.nodeSize + delta));
        await this.service.render();
    }
}

export default PageKieraStatusComponent;
